module.exports = __webpack_public_path__ + "static/img/cate.f327cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/cate.jpg
// module id = ZjbF
// module chunks = 1